import { FormStore, useStoreState } from '@ariakit/react'
import { FC } from 'react'

import { ProductCatalogEmbroideryPlacement } from '../../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useEmbroidery } from '../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import {
  B2bLogoAndTextFormValues,
  EmbroideryFormKind,
  TextFormValues,
} from '../../../../../../containers/EmbroideryContainer/types'
import { PlacementSelector } from '../../../../Modal/primitives/selectors/PlacementSelector/PlacementSelector'
import { EmbroideryOptionWrapper } from '../../../../Modal/primitives/shared-form-styles'

interface Props {
  labelId: string
  placementOptions: ProductCatalogEmbroideryPlacement[] | null | undefined
  form: FormStore<TextFormValues | B2bLogoAndTextFormValues>
  kind: EmbroideryFormKind | null
  disabled?: boolean
}

export const TextPlacement: FC<Props> = ({ labelId, placementOptions, form, kind, disabled }) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const { setCurrentPlacement } = useEmbroidery()

  const textPlacement = useStoreState(form, s => s.values.textPlacement)
  const errorMessage = useStoreState(form, () =>
    form.getFieldTouched('textPlacement') ? form.getError('textPlacement') : undefined
  )

  const handleSelectPlacement = (placement: ProductCatalogEmbroideryPlacement) => {
    setCurrentPlacement(kind, placement)
    form.setValue('textPlacement', placement)
  }

  if (!placementOptions) return null

  return (
    <EmbroideryOptionWrapper>
      <PlacementSelector
        errorMessage={errorMessage ?? undefined}
        label={fixtures.textOption.textPlacementLabel}
        labelId={labelId}
        onSelectPlacement={handleSelectPlacement}
        placementOptions={placementOptions}
        selectedPlacementOption={textPlacement ?? placementOptions[0]}
        disabled={disabled}
      />
    </EmbroideryOptionWrapper>
  )
}
